<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo" style="width: 800px !important;">
            <div class="contenedor_modal_cabecera">
                <button type="button" class="btn btn-sm btn-danger" @click="cerrar"><i
                        class="fas fa-times"></i></button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Detalle de Anticipo
                        </h3>
                    </div>
                    <div class="col-sm-12" style="font-size: 25px;">
                        Monto: Q{{ capital.monto }}
                    </div>
                    <div class="col-sm-12 mt-3">
                        <div class="contenedor_detalle_registros">
                            <table class="table table-sm table-striped table-bordered" style="font-size: 13px;">
                                <thead>
                                    <tr>
                                        <th style="width: 40%;">
                                            Comentarios
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Tipo de Pago
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Monto
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Dif. Efectivo
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Dif. Tarjeta
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in registros_filtrados" :key="index">
                                        <td>
                                            {{ item.comentarios }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.tipo_pago }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ item.monto.toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ item.dif_efectivo | valorCero }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ item.dif_tarjeta | valorCero }}
                                        </td>
                                    </tr>
                                </tbody>

                            </table>
                        </div>
                    </div>
                    <!-- El contenido del modal estará vacío como solicitaste -->
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ModalDetalleAnticipos',
        components: {
        },
        props: ['capital', 'registros'],
        filters: {
            valorCero: function (valor) {
                return valor === null || valor === undefined || valor === '' ? 0 : valor.toLocaleString(undefined, {
                    minimumFractionDigits: 2, maximumFractionDigits: 2
                });
            }
        },
        data() {
            return {
                registros_filtrados: []
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            filtrarPorCorrelativo(correlativo) {
                let filtro = this.registros.filter(item => item.correlativo_anticipo === correlativo);
                this.registros_filtrados = filtro;
            }
        },
        mounted() {
            this.filtrarPorCorrelativo(this.capital.correlativo_anticipo)
        },
    }
</script>

<style>
    .contenedor_detalle_registros {
        width: 100%;
        height: 400px;
        overflow: auto;
        margin-bottom: 10px;
    }
</style>